export default {
  'pages.system.menu.title': 'メニュー管理',
  'pages.system.menu.name': 'メニュー名',
  'pages.system.menu.path': 'パス',
  'pages.system.menu.icon': 'アイコン',
  'pages.system.menu.order': '並び順',
  'pages.system.menu.enabled': '有効',
  'pages.system.menu.add': 'メニュー追加',
  'pages.system.menu.edit': 'メニュー編集',
  'pages.system.menu.delete': '削除',
  'pages.system.menu.confirm': '削除確認',
  'pages.system.menu.confirmContent': 'このメニューを削除しますか？',
  'pages.system.menu.deleteSuccess': '削除しました',
  'pages.system.menu.updateSuccess': '更新しました',
  'pages.system.menu.addSuccess': '追加しました',
  'pages.system.menu.namePlaceholder': 'メニュー名を入力してください',
  'pages.system.menu.pathPlaceholder': 'パスを入力してください',
  'pages.system.menu.iconPlaceholder': 'アイコン名を入力してください',
  'pages.system.menu.orderPlaceholder': '並び順を入力してください',
  'pages.system.menu.nameRequired': 'メニュー名を入力してください',
  'pages.system.menu.pathRequired': 'パスを入力してください',
  'pages.system.menu.iconRequired': 'アイコンを入力してください',
  'pages.system.menu.orderRequired': '並び順を入力してください',
  'pages.system.menu.enable': '有効',
  'pages.system.menu.disable': '無効',
  'pages.system.menu.cancel': 'キャンセル',
  'pages.system.menu.submit': '送信',

  'pages.system.user.title': 'ユーザー管理',
  'pages.system.user.username': 'ユーザー名',
  'pages.system.user.email': 'メール',
  'pages.system.user.phone': '電話',
  'pages.system.user.role': 'ロール',
  'pages.system.user.status': '状態',
  'pages.system.user.add': 'ユーザー追加',
  'pages.system.user.edit': 'ユーザー編集',
  'pages.system.user.delete': '削除',
  'pages.system.user.confirm': '削除確認',
  'pages.system.user.confirmContent': 'このユーザーを削除しますか？',
  'pages.system.user.deleteSuccess': '削除しました',
  'pages.system.user.updateSuccess': '更新しました',
  'pages.system.user.addSuccess': '追加しました',
  'pages.system.user.usernamePlaceholder': 'ユーザー名を入力してください',
  'pages.system.user.emailPlaceholder': 'メールアドレスを入力してください',
  'pages.system.user.phonePlaceholder': '電話番号を入力してください',
  'pages.system.user.usernameRequired': 'ユーザー名を入力してください',
  'pages.system.user.emailRequired': 'メールアドレスを入力してください',
  'pages.system.user.emailInvalid': 'メールアドレスの形式が正しくありません',
  'pages.system.user.phoneRequired': '電話番号を入力してください',
  'pages.system.user.roleRequired': 'ロールを選択してください',
  'pages.system.user.statusRequired': '状態を選択してください',
  'pages.system.user.admin': '管理者',
  'pages.system.user.normalUser': '一般ユーザー',
  'pages.system.user.enable': '有効',
  'pages.system.user.disable': '無効',
  'pages.system.user.cancel': 'キャンセル',
  'pages.system.user.submit': '送信',

  'pages.system.role.title': 'ロール管理',
  'pages.system.role.name': 'ロール名',
  'pages.system.role.description': '説明',
  'pages.system.role.permissions': '権限数',
  'pages.system.role.add': 'ロール追加',
  'pages.system.role.edit': 'ロール編集',
  'pages.system.role.delete': '削除',
  'pages.system.role.confirm': '削除確認',
  'pages.system.role.confirmContent': 'このロールを削除しますか？',
  'pages.system.role.deleteSuccess': '削除しました',
  'pages.system.role.updateSuccess': '更新しました',
  'pages.system.role.addSuccess': '追加しました',
  'pages.system.role.namePlaceholder': 'ロール名を入力してください',
  'pages.system.role.descriptionPlaceholder': '説明を入力してください',
  'pages.system.role.nameRequired': 'ロール名を入力してください',
  'pages.system.role.descriptionRequired': '説明を入力してください',
  'pages.system.role.permissionsRequired':
    '少なくとも 1 つの権限を選択してください',
  'pages.system.role.permissionConfig': '権限設定',
  'pages.system.role.cancel': 'キャンセル',
  'pages.system.role.submit': '送信',
};
